import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import AbellioMenue from '../custom_controls/TransdevMenue';
import Contracts from '../components/vas/Contracts';
import CustomerCard from '../components/vas/CustomerCard';
import ChangePassword from "../components/ChangePassword";
import Account from '../components/vas/Account';
import DocumentOverView from "../components/vas/CustomerCard/CustomerDocumentData";
import Footer from '../components/Footer';
import OrderContract from "../components/OrderContract";
import Vas from '../Vas';
import CustomerPayment from "../components/vas/CustomerCard/CustomerPaymentData";
import VerificationOverView from "../components/vas/CustomerCard/CustomerVerificationData";
import ContractCard from "../components/vas/ContractCard";
import ChangePasswordSuccess from "../components/ChangePasswordSuccess";
import OrderSuccess2 from "./OrderSuccess2";
import NoPayment from "../components/NoPayment";
import CreatePayment from "../components/vas/CreatePayment";
import CreatePaymentSuccess from "../components/vas/CreatePaymentSuccess";
import ErrorOnline from "../components/ErrorOnline";
import DocumentUpload from '../components/vas/CustomerCard/DocumentUpload';
import CustomerDocumentUploadSuccess from '../components/vas/CustomerCard/CustomerDocumentUploadSuccess';
import VerificationUpload from '../components/vas/CustomerCard/VerificationUpload';
import CustomerVerificationUploadSuccess from '../components/vas/CustomerCard/CustomerVerificationUploadSuccess';
import ContractCancel from '../components/ContractCancel';
import ContractCancelSuccess from '../components/ContractCancelSuccess';
import Customers from '../components/vas/Customers';
import CreateCustomer from '../components/vas/CreateCustomers';
import CreateCustomerSuccess from '../components/vas/CreateCustomerSuccess';
import ContractEditState from '../components/vas/ContractCard/ContractEditState';
import ContractEditStateSuccess from '../components/vas/ContractCard/ContractEditStateSuccess';
import CreateAdditionalAddresses from '../components/vas/CustomerCard/CreateAdditionalAddress';
import CreateAdditionalAddressesSuccess from '../components/vas/CustomerCard/CreateAdditionalAddressSuccess';
import ChangePaymentSuccess from '../components/vas/ChangePaymentSuccess';
import CustomerRelationDelete from '../components/vas/CustomerCard/CustomerRelationDelete';
import Home from '../components/Home';
import CustomerRelationDeteleSuccess from '../components/vas/CustomerCard/CustomerRelationDeleteSuccess';
import ChangeEmail from '../components/vas/CustomerCard/ChangeEmail';
import ChangeEmailSuccess from '../components/vas/CustomerCard/ChangeEmailSuccess';
import ActivateEMail from "../components/ActivateEMail";
import ActivateEMailSuccess from '../components/ActivateEMailSuccess';
import VerificationReupload from '../components/VerificationReupload';


import $ from 'jquery';


class Main extends Component
{
    componentDidMount(){
        $("#HeaderTitle").html(Vas.Resources.Menus["Home"]);
    }

    render(){
        return (
          <div>            
            <AbellioMenue />
            {/*<div style={{ margin: '60px',textAlign:'center' }}>*/}
            <div style={{ margin: '60px',textAlign:'center',marginTop: "150px" }}>
              <Switch>
                <Route
                  path='/Contracts/:all'
                  component={Contracts} />
                <Route
                  path='/Account'
                  component={Account} />
                <Route
                  path='/contractcard/:ContractID/:CustomerId/:CustomerName'
                  component={ContractCard} />
                <Route
                  path='/CustomerCard/:id'
                  component={CustomerCard} />
                <Route
                  path='/ChangePasswordSuccess'
                  component={ChangePasswordSuccess} />
                <Route
                  path='/ChangePassword'
                  component={ChangePassword} />
                <Route
                  path='/documentOverView'
                  component={DocumentOverView} />
                <Route
                  path='/orderContract/:CustomerId/:ContractId'
                  component={OrderContract} />
                <Route
                  path='/customerPayment'
                  component={CustomerPayment} />
                <Route
                  path='/verificationOverView'
                  component={VerificationOverView} />
                <Route                    
                  path='/orderSuccess'
                  component={OrderSuccess2} />
                <Route                    
                  path='/noPayment/:CustomerId/:NewContract'
                  component={NoPayment} />
                <Route                    
                  path='/createPayment/:CustomerId/:NewContract/:PaymentId'
                  component={CreatePayment} />
                <Route                    
                  path='/createPaymentSuccess/:CustomerId'
                  component={CreatePaymentSuccess} />
                <Route                    
                  path='/errorOnline'
                  component={ErrorOnline} />
                <Route                    
                  path='/documentUpload/:CustomerId'
                  component={DocumentUpload} />
                <Route                    
                  path='/documentUploadSuccess/:CustomerId'
                  component={CustomerDocumentUploadSuccess} />
                <Route                    
                  path='/verificationUpload/:CustomerId'
                  component={VerificationUpload} />
                <Route                    
                  path='/verificationUploadSuccess/:CustomerId'
                  component={CustomerVerificationUploadSuccess} />
                <Route
                  path='/contractCancel'
                  component={ContractCancel} />
                <Route
                  path='/contractCancelSuccess/:CustomerId/:ContractId/:CustomerName'
                  component={ContractCancelSuccess} />
                <Route
                  path='/customers'
                  component={Customers} />
                <Route
                  path='/createCustomer'
                  component={CreateCustomer} /> 
                <Route
                  path='/createCustomerSuccess'
                  component={CreateCustomerSuccess} />  
                <Route
                  path='/contractEditState/:CustomerId/:ContractId/:CustomerName'
                  component={ContractEditState} />
                <Route
                  path='/contractEditStateSuccess/:CustomerId/:ContractId/:CustomerName'
                  component={ContractEditStateSuccess} />
                <Route
                  path='/createAdditionalAddress/:CustomerId'
                  component={CreateAdditionalAddresses} />
                <Route
                  path='/createAdditionalAddressSuccess/:CustomerId'
                  component={CreateAdditionalAddressesSuccess} />
                <Route                    
                  path='/changePaymentSuccess/:CustomerId'
                  component={ChangePaymentSuccess} />
                <Route                    
                  path='/customerRelationDelete/:CustomerId'
                  component={CustomerRelationDelete} />
                <Route
                  path='/customerRelationDeleteSuccess/:CustomerId'
                  component={CustomerRelationDeteleSuccess} />
                <Route                    
                  path='/home'
                  component={Home} />
                <Route
                  path='/changeEmail/:CustomerId/:Email'
                  component={ChangeEmail} />  
                <Route
                  path='/changeEmailSuccess/:CustomerId'
                  component={ChangeEmailSuccess} />
                <Route
                  path='/changeMail/:id'
                  component={ActivateEMail} />
                <Route
                  path='/activateEMailSuccess'
                  component={ActivateEMailSuccess} />
                <Route
                  path='/verificationReupload'
                  component={VerificationReupload} />
              </Switch>
            </div>
            <Footer />
          </div>
        );
    }
}
export default Main;
